"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _HeaderFinancing = require("./HeaderFinancing.styles");

var _MenuButton = _interopRequireDefault(require("../../Shared/MenuButton"));

var _MenuLine = _interopRequireDefault(require("../../Shared/MenuLine"));

var _MenuProvider = require("../../Shared/MenuProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _ref3 = _react.default.createElement(_HeaderFinancing.DropDownButton, {
  dataCvTest: "headerFinanceLearn",
  href: "/learn-financing",
  target: "_self"
}, "Why Finance With Carvana");

var _ref4 = _react.default.createElement(_MenuLine.default, null);

var _ref5 = _react.default.createElement(_HeaderFinancing.DropDownButton, {
  dataCvTest: "headerFinancePrequal",
  href: "/financing-prequalification",
  target: "_self"
}, "Get Prequalified");

var _ref6 = _react.default.createElement(_MenuLine.default, null);

var _ref7 = _react.default.createElement(_HeaderFinancing.DropDownButton, {
  dataCvTest: "headerFinanceLoanCalc",
  href: "/auto-loan-calculator",
  target: "_self"
}, "Auto Loan Calculator");

var HeaderFinancing = function HeaderFinancing(_ref) {
  var isActive = _ref.isActive;
  return _react.default.createElement(_MenuProvider.MenuContext.Consumer, {
    "data-qa": "header-financing"
  }, function (_ref2) {
    var isFinancingExpanded = _ref2.isFinancingExpanded,
        setFinancingMenuState = _ref2.setFinancingMenuState;
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_HeaderFinancing.MenuWrapper, {
      "data-cv-test": "headerFinanceDropdown",
      isDropdownExpanded: isFinancingExpanded,
      onMouseEnter: function onMouseEnter() {
        return setFinancingMenuState(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setFinancingMenuState(false);
      },
      isActive: isActive
    }, _react.default.createElement(_MenuButton.default, {
      onTouchStart: function onTouchStart() {
        return setFinancingMenuState(!isFinancingExpanded);
      }
    }, _react.default.createElement(_HeaderFinancing.MenuTitle, {
      isDropdownExpanded: isFinancingExpanded,
      isActive: isActive
    }, "Financing"), _react.default.createElement(_HeaderFinancing.StyledArrowDropDown, {
      isDropdownExpanded: isFinancingExpanded,
      isActive: isActive
    })), _react.default.createElement(_HeaderFinancing.StyledDropDown, {
      isDropdownExpanded: isFinancingExpanded
    }, _ref3, _ref4, _ref5, _ref6, _ref7)), _react.default.createElement(_HeaderFinancing.OutsideClickWrapper, {
      isDropdownExpanded: isFinancingExpanded,
      onTouchStart: function onTouchStart() {
        return setFinancingMenuState(false);
      }
    }));
  });
};

var _default = HeaderFinancing;
exports.default = _default;
module.exports = exports.default;